<template>
  <div>
    <img class="d-flex justify-center seedling-img" src="seedling.png" />

    <div class="error-message d-flex justify-center">{{ errorMessage }}</div>

    <div class="d-flex justify-center">
      <v-sheet class="input-form">
        <v-row class="d-flex justify-center">
          <div class="login-word">password reset</div>
        </v-row>
        <v-row>
          <div class="label">email</div>
        </v-row>
        <v-row>
          <v-text-field
            id="js-email"
            v-model="email"
            filled
            single-line
            dense
            outlined
            class="ma-4 input-field"
            background-color="#f2eae2"
            color="#35606f"
          ></v-text-field>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-btn
            id="js-login"
            class="login-btn default-action-btn"
            @click="submit"
          >
            Submit
          </v-btn>
        </v-row>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import { UsersAPI } from "@/lib/api"

export default {
  data: function() {
    return {
      email: "",
      errorMessage: ""
    }
  },
  methods: {
    submit: function() {
      UsersAPI.requestPasswordReset(this.email).then(
        response => {
          // console.log(response)
          this.errorMessage = response.data
        },
        error => {
          console.log(error)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

$section-width: 300px;

.input-form {
  width: $section-width;
  margin-top: 75px;
  padding: 50px 30px 0px 30px;
  border-radius: 25px;
}

.label {
  color: $dark-blue;
  font-weight: 800;
  margin: 0px 0px -15px 20px;
}

.seedling-img {
  max-width: 200px;
  margin: 20px auto 0px auto;
}

.login-btn {
  width: 175px;
  margin-top: 10px;
  margin-bottom: 40px;
}

.login-word {
  font-style: italic;
  color: $light-yellow;
  font-size: 1.8em;
  text-transform: uppercase;
  font-weight: 500;
  padding-bottom: 20px;
}

.error-message {
  margin: 0px auto;
  font-family: $main-font-family;
  font-weight: 700;
  color: $orange;
  font-size: 1.8em;
  padding-bottom: 20px;
  max-width: 400px;
}
</style>
